/**
 * City Content View Page
 * Shows all content from a specific AnaVatan city in a grid layout
 * Route: /anavatan/city?city=<cityKey>&province=<provinceKey>&name=<displayName>
 */
import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import RootLayout from "../../layout";
import PageLayout from "../../../components/layout/PageLayout";
import httpService from "../../../services/http.service";
import { getCMSApiRoute } from "../../../utils/api.utils";
import { startLoading, stopLoading } from "../../../redux/Slices/loading.slice";
import { getAgeRangePublicRoute } from "../../../utils/ageRange.util";
import GridContent from "../../../components/anaVatan/content-grid/content";

const CityContentPage = () => {
    const [searchParams] = useSearchParams();
    const cityKey = searchParams.get("city");
    const provinceKey = searchParams.get("province");

    const [contents, setContents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const dispatch = useDispatch();

    const fetchCityContent = useCallback(async (pageNumber) => {
        if (pageNumber === 1) {
            dispatch(startLoading(`در حال بارگذاری محتوای شهر ${cityKey}...`));
            setLoading(true);
        }

        try {
            const ageRange = getAgeRangePublicRoute();
            const response = await httpService.get(getCMSApiRoute("content"), {
                params: {
                    pageIndex: 24,
                    pageNumber: pageNumber,
                    anaVatanCity: cityKey,
                    anaVatanProvince: provinceKey,
                    isAnaVatan: true,
                    contentAgeRange: ageRange,
                },
            });

            if (response.status === 200) {
                const results = response.data?.data?.results || [];
                const totalCount = response.data?.data?.total || 0;

                if (pageNumber === 1) {
                    setContents(results);
                } else {
                    setContents(prev => [...prev, ...results]);
                }

                setTotal(totalCount);
                setHasMore(contents.length + results.length < totalCount);
                setPage(pageNumber);
            }
        } catch (error) {
            console.error("Error fetching city content:", error);
        } finally {
            setLoading(false);
            dispatch(stopLoading());
        }
    }, [cityKey, provinceKey, dispatch, contents.length]);

    useEffect(() => {
        if (cityKey) {
            fetchCityContent(1);
        }
    }, [cityKey, provinceKey]);

    const loadMore = useCallback(() => {
        if (hasMore && !loading) {
            fetchCityContent(page + 1);
        }
    }, [hasMore, loading, page, fetchCityContent]);

    return (
        <RootLayout>
            <PageLayout loading={loading} skeletonType="contentGrid">
                <GridContent data={contents} title={cityKey} onLoadMore={loadMore} hasMore={hasMore} isLoading={loading} />
            </PageLayout>
        </RootLayout>
    );
};

export default CityContentPage;
